module.exports = __webpack_public_path__ + "img/sortdown.c6a90fc9.svg";